import React from 'react';
import { observer } from 'mobx-react-lite';

import { ProductKit } from '../../starter-kit-selection/model/ProductKit';
import { useRootStore } from '../../../root/RootStoreHooks';
import { MoneyDisplay } from '../../starter-kit-selection/util-starter-kit/MoneyDisplay';

interface Props {
  kit: ProductKit;
}

export const KitPriceDisplay = observer<Props>(({ kit }) => {
  const rootStore = useRootStore();
  return (
    <p className="text-white pr-2 pt-2">
      <MoneyDisplay numberOnly={!rootStore.moduleStores.isFlagPriceEnabled} price={kit.price} />
    </p>
  );
});
